import { Injectable } from "@angular/core";
import { catchError } from "rxjs/internal/operators/catchError";
import { EMPTY } from "rxjs/internal/observable/empty";
import { VerificateModel } from "./verificate.model";
import { ToastrService } from "ngx-toastr";
import { showToastr } from "@shared/common";
import { ConfigService } from "@app/config.service";

@Injectable({
  providedIn: "root",
})
export class VerificateService {
  url: string;
  model: Partial<VerificateModel> = new VerificateModel();

  constructor(
    private configService: ConfigService,
    private toastr: ToastrService
  ) {
    this.url = this.configService.getUrlApi("api/Verificate/");
  }

  verificarStatus(numeroDoc: string, callback?: Function) {
    return this.configService.http
      .get(`${this.url}VerificarStatus/${numeroDoc}`)
      .pipe(
        catchError(() => {
          this.model = new VerificateModel();
          return EMPTY;
        })
      )
      .subscribe((response: any) => {
        if (!response.RazonSocial) {
          showToastr(this.toastr, `Rnc/Cédula no encontrado.`, "error");
          return;
        }
        this.model = response;
        if (callback) callback(response.CodigoRegistro);
      });
  }
}
